import React from 'react'
import ReactDom from 'react-dom'
// import { setModel } from 'src/utils/global'
import StoreProvider from 'src/components/storeProvider'
import useUpdateData from 'src/hooks/useUpdateData'
import createAllStore from 'src/store'
import type { ModelType } from 'src/types'
// import App from './App'

function renderModelDOM(obj: {
  model: ModelType
  App: React.ComponentType
  type?: 'async'
  store: ReturnType<typeof createAllStore>
}, callback: (root: HTMLElement) => void) {
  const { App, model, store, type } = obj
  callback(model.dom)
  if (type === 'async') {
    ReactDom.render(
      <StoreProvider store={store}>
        <App />
      </StoreProvider>,
      model.dom!,
    )
  }
  else {
    // NOTE: 根据具体打包产物来写
    window.KDApi.loadFile('./main.css', model, () => {
      ReactDom.render(
        <StoreProvider store={store}>
          <App />
        </StoreProvider>,
        model.dom!,
      )
    })
  }
}

let count = 1

export class Flow {
  model: ModelType

  globalRoot: HTMLElement | null

  store: ReturnType<typeof createAllStore>

  handleUpdateData: ReturnType<typeof useUpdateData>[0]

  constructor(model: ModelType) {
    const { dom } = model
    if (!dom) {
      throw new Error('cannot find root dom')
    }
    this.model = model
    model.invokeAsync('init', {})
    // setModel(this.model)
    const store = createAllStore({ name: `store_${count++}` })
    this.store = store
    store.getState().setModel(model)
    this.handleUpdateData = useUpdateData(store)[0]
    // NOTE: 用import("./App").then语法配合代码分割+css独立文件打包，可以让打包后的js文件自动拉取css文件
    import('../../App').then((AppModule) => {
      const App = AppModule.default
      renderModelDOM(
        { model: this.model, store, App, type: 'async' },
        (root: HTMLElement) => {
          this.globalRoot = root
        },
      )
    })
    // renderModelDOM({ model: this.model, store, App })
  }

  init(props: any) {
    console.log('-----init skill', props)
    this.handleUpdateData(props.data)
  }

  update(props: any) {
    console.log('-----update skill', props)
    this.handleUpdateData(props.data)
    // 添加 setTimeout 防止更新节点切换时，默认节点 到异步获取的节点之间的闪烁
    setTimeout(() => {
      if (this.store.getState().isInit) {
        this.store.getState().setInitState(false)
      }
    }, 16)
  }

  destoryed() {
    console.log('-----destroyed')
    if (this.globalRoot) {
      ReactDom.unmountComponentAtNode(this.globalRoot)
      this.globalRoot = null
    }
  }
}
